import { render, staticRenderFns } from "./MaterialManageList.vue?vue&type=template&id=27897d42&scoped=true&"
import script from "./MaterialManageList.vue?vue&type=script&lang=js&"
export * from "./MaterialManageList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialManageList.vue?vue&type=style&index=0&id=27897d42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27897d42",
  null
  
)

export default component.exports